import { createVanIconComponent } from "./van"

const BalanceListOutlined = createVanIconComponent("balance-list-o")
export default BalanceListOutlined
